var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-default header-list-space-button",on:{"click":_vm.logSpaceListingClick}},[_c('p-icon-svg'),_vm._v(" "),_c('span',[_vm._v("\n        List your Space for free\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }